import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navbar } from "../components/Navbar";
import { Hero } from "../components/sections/Hero";
import { WhyThisMatters } from "../components/sections/WhyThisMatters";
import { OurVision } from "../components/sections/OurVision";
import { StockistCTA } from "../components/sections/StockistCTA";
import { Founder } from "../components/sections/Founder";
import { Connect } from "../components/sections/Connect";
import { Footer } from "../components/sections/Footer";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const el = document.querySelector(location.hash);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: "smooth" }), 300);
      }
    }
  }, [location]);

  return (
    <div data-testid="landing-page" className="relative bg-softwhite">
      <Navbar />
      <main>
        <Hero />
        <WhyThisMatters />
        <OurVision />
        <StockistCTA />
        <Founder />
        <Connect />
      </main>
      <Footer />
    </div>
  );
}
